import { render, staticRenderFns } from "./MicroportalItem.vue?vue&type=template&id=0609d60c"
import script from "./MicroportalItem.vue?vue&type=script&lang=js"
export * from "./MicroportalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports